import { rando } from '../../lib/rando-sidecar'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { voyageMessageCrewCarry } from './multi/voyageMessageCrewCarry-sidecar'
import { EVoyageCrewCreateMethod } from './multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './multi/voyageMessageCrewCreate-sidecar'
import { EEffectCommand } from './multi/voyageMessageEffectCommand'
import { voyageMessageEffectCommand } from './multi/voyageMessageEffectCommand-sidecar'
import {
  EVoyageEnemyShipCommand,
  EVoyageEnemyShipType,
} from './multi/voyageMessageEnemyShipCommand'
import { voyageMessageEnemyShipCommand } from './multi/voyageMessageEnemyShipCommand-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import { EVoyageCrewType } from './voyageCrew'
import { voyageGameMode_game_hyperspace } from './voyageGameMode_game_hyperspace-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

let _directorTimer = 0
let _directorTime = 25
let _adaptiveDifficulty = 0.97 // 0.965

let _superTestMode = false && voyageTestParams.isDevMode
let _events = ['boarded', 'fire', 'ship', 'nothing', 'hull-breach', 'bomb']
if (_superTestMode) {
  _directorTime = 10
  _directorTimer = _directorTime
  // _events = ['fire', 'hull-breach']
  _events = ['boarded']
}

export function signalAction() {
  _directorTimer = _directorTime
}

export function* generator_director(): Generator<number, number, number> {
  voyageGameStatus.get().isGameStarted = true
  voyageGameStatus.get().isGameEnded = false

  let maxAliens = 4

  let hyper = voyageGameMode_game_hyperspace.generator_hyperspace()

  while (true) {
    let ds = common.getUpdateDeltaScaled()

    hyper.next()
    if (voyageGameMode_game_hyperspace.getIsInHyperspace()) {
      yield 0
      continue
    }

    let status = voyageGameStatus.get()
    if (!status.isGameEnded && !status.isAtStarbase) {
      _directorTimer += ds
    } else {
      _directorTime = 25 // Reset difficulty
      _directorTimer = 0
    }

    // console.log(_directorTimer, _directorTime)

    if (_directorTimer > _directorTime) {
      _directorTimer = 0 // -= _directorTime
      // Adaptive difficulty, maybe
      _directorTime *= _adaptiveDifficulty

      // console.log(
      //   'dis?',
      //   voyageTestParams.disableDirector || !voyageWebsockets.getIsHost(),
      // )
      if (voyageTestParams.disableDirector || !voyageWebsockets.getIsHost()) {
        yield 0
        continue
      }

      // let events = ['boarded']

      let event = rando.sample(_events)
      console.log('EVENT', event)

      if (event === 'fire') {
        // let fl = voyageTilemap.getRandomFloor()
        // let fire = voyageCrew.create(EVoyageCrewType.Fire, -1)
        // voyageCrew.moveToIJ(fire, fl)

        voyageGameStatus_enemyShips.hitByWeapon(0.9, 100, 0, false)
      }

      if (event === 'hull-breach') {
        voyageGameStatus_enemyShips.hitByWeapon(0.9, 0, 100)

        // let fl = voyageTilemap.getRandomFloor()
        // let breach = voyageCrew.create(EVoyageCrewType.HullBreach, -1)
        // voyageCrew.moveToIJ(breach, fl)
      }

      if (event === 'ship') {
        voyageMessageEnemyShipCommand.sendMessageAndImmediatelyExecute({
          command: EVoyageEnemyShipCommand.Create,
          type: EVoyageEnemyShipType.Hammerhead,
        })
      }
      if (event === 'boarded') {
        let num = rando.i(Math.floor(maxAliens / 2), Math.floor(maxAliens))
        maxAliens += 0.25

        for (let i = 0; i < num; i++) {
          setTimeout(() => {
            let fl = voyageTilemap.getRandomFloor()
            voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
              crewId: createId(),
              i: fl.i,
              j: fl.j,
              team: 1,
              type: EVoyageCrewType.Alien,
              method: EVoyageCrewCreateMethod.Teleport,
              energy: 0,
            })
          }, 1000 * i)

          // let entrance = voyageTilemap.getRandomLanding()
          // voyageCrew.moveToIJ()
        }
      }

      if (event === 'bomb') {
        let maxBombs = 2
        let num = rando.i(Math.floor(maxBombs / 2), Math.floor(maxBombs))
        maxBombs += 0.25

        for (let i = 0; i < num; i++) {
          setTimeout(() => {
            let fl = voyageTilemap.getRandomFloor()

            let type = rando.sample([
              EVoyageCarryableType.Breachbomb,
              EVoyageCarryableType.Firebomb,
            ])

            voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
              i: fl.i,
              j: fl.j,
              type: type,
            })

            voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
              command: EEffectCommand.HitParticles,
              x: fl.x,
              y: fl.y,
            })
          }, 1000 * i)

          // let entrance = voyageTilemap.getRandomLanding()
          // voyageCrew.moveToIJ()
        }
      }
    }
    yield 0
  }
}
